<template>
  <div class="course">
    <Header msg='我的课表'/>
    <div style="height:0.44rem;"></div>
    <img src="@/assets/mine/my_bg_course@3x.png" class="course-null" v-if="shownull">
    <div class="course-choose">
        <!-- 学校 -->
        <div class="per-line">
            <div class="flex flex-j-c-sb flex-a-i-center">
                <span class="courseTitle-left ellipsis">{{pageData.first_name || "---"}}({{pageData.second_name || "---"}})</span>
                <div class="courseTitle-right flex flex-j-c-center flex-a-i-center">
                    <p>辅导课</p>
                    <img src="@/assets/mine/my_icon_ddm@3x.png" class="courseChoose-btn">
                </div>
            </div>
        </div>
        <!-- 专业 -->
        <div class="per-line">
            <div class=" flex flex-j-c-sb">
                <span><i class="text-grey">开课专业：</i>{{pageData.goods_name}}</span>
                <div></div>
            </div>
        </div>
    </div>
    <div class="course-context">
        <Navbar :selected.sync="selected" :selecteData="selecteData"/>
        <div class="per-line" @click="toCourseDetail(e)" v-for="(e,i) in menuList" :key="i">
            <div class=" flex flex-j-c-sb">
                <span>{{e.name}}</span>
                <div class="flex flex-j-c-e method-right">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <!-- <div class="per-line" @click="toCourseDetail">
            <div class=" flex flex-j-c-sb">
                <span>政治</span>
                <div class="flex flex-j-c-e method-right">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <div class="per-line" @click="toCourseDetail">
            <div class=" flex flex-j-c-sb">
                <span>数学</span>
                <div class="flex flex-j-c-e method-right">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import { MessageBox } from 'mint-ui';

export default {
  name: 'Course',
  components: {
    Header,
    Navbar
  },
  data() {
    return {
      shownull: false,
      selected: 0, // Navbar索引
      // selecteData: [{name:'在线课程',num: 0}, {name:'线下课程',num: 0}],
      selecteData: [{name:'在线课程',num: 0}], // Navbar数据
      pageData: {}, // 页面数据
      menuList:[{name:'语文',type:'CH'}, {name:'数学',type:'MA'}, {name:'英语',type:'EN'}] // 课程列表
    }
  },
  created() {
    this.pageData = JSON.parse(sessionStorage.getItem('_userType'));
    if (this.pageData.is_pay !== 1) {
      MessageBox.alert('请先进行报名操作...').then(action => {
        this.$router.go(-1);
      });
    }
    if (this.pageData.second_name === "高升专" || this.pageData.second_name === "高升本") {
      this.menuList = [{name:'语文',type:'HCH'}, {name:'数学',type:'HMA'}, {name:'英语',type:'HEN'}];
    } else {
      this.menuList = [{name:'政治',type:'CPO'}, {name:'数学',type:'CMA'}, {name:'英语',type:'CEN'}];
    }
  },
  mounted () {
    // MessageBox.alert('功能完善中...').then(action => {
    //   this.$router.go(-1);
    // });
  },
  methods: {
    // 跳转课程详情
    toCourseDetail(e) {
      switch (e.type) {
        case 'HCH':
          this.pageData.videoType = 'HChinese';
          this.pageData.videoText = '语文基础(专科)';
          break;
        case 'HMA':
          this.pageData.videoType = 'HMath';
          this.pageData.videoText = '数学基础(专科)';
          break;
        case 'HEN':
          this.pageData.videoType = 'HEnglish';
          this.pageData.videoText = '英语基础(专科)';
          break;
        case 'CPO':
          this.pageData.videoType = 'CPolitics';
          this.pageData.videoText = '政治基础(本科)';
          break;
        case 'CMA':
          this.pageData.videoType = 'CMath';
          this.pageData.videoText = '数学基础(本科)';
          break;
        case 'CEN':
          this.pageData.videoType = 'CEnglish';
          this.pageData.videoText = '英语基础(本科)';
          break;
        default:
          break;
      }
      sessionStorage.setItem('_userType', JSON.stringify(this.pageData));
      this.$router.push({name:'CourseDetail'});
    }
  },
  watch: {
    selected(newVal, oldVal) {
      if (newVal === 1) {
        MessageBox.alert('暂无线下课程...');
        this.selected = 0;
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .course{
    min-height: 100vh;
    font-size: 0.15rem;
    position: relative;
    .course-null{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.48rem;
        height: 1.74rem;
    }
    .course-choose{
        padding: 0 0.16rem;
        background-color: white;
        margin-top: 0.1rem;
        &>:last-child{
            border: none;
        }
        .courseTitle-left{
            font-size: 0.15rem;
            font-weight: bold;
            display: inline-block;
            max-width: 75%;
        }
        .courseTitle-right{
            width: 0.7rem;
            height: 0.3rem;
            border: 1px solid #FABF01;
            border-radius: 4px;
            p{
                color: #FABF01;
            }
            .courseChoose-btn{
                width: 0.1rem;
                height: 0.06rem;
                margin-left:2px; 
            }
        }
    }
    .Navbar{
        border-bottom: 1px solid #EEEEEE;
    }
    .course-context{
        background: white;
        margin-top: 0.1rem;
        .per-line{
            padding: 0 0.16rem;
        }
    }
  }
</style> 

